import service from './service';

export default {
  // 收到的简历申请
  getApplyList(infoId, pageIndex, pageSize, remark, pageSort) {
    return service({
      url: '/api/v1/company/resume/apply/list',
      method: 'get',
      params: {
        pageIndex: pageIndex,
        pageSize: pageSize,
        pageSort: pageSort,
        remark: remark,
        info_id: infoId
      }
    });
  },
  // 收藏的简历申请
  getCollectList(pageIndex, pageSize, pageSort) {
    return service({
      url: '/api/v1/company/resume/collect/list',
      method: 'get',
      params: {
        pageIndex: pageIndex,
        pageSize: pageSize,
        pageSort: pageSort
      }
    });
  },
  // 面试邀请
  getInviteList(pageIndex, pageSize, pageSort) {
    return service({
      url: '/api/v1/company/resume/invite/list',
      method: 'get',
      params: {
        pageIndex: pageIndex,
        pageSize: pageSize,
        pageSort: pageSort
      }
    });
  },
  // 我浏览过的简历列表
  getViewsList(pageIndex, pageSize, pageSort) {
    return service({
      url: '/api/v1/company/resume/views/list',
      method: 'get',
      params: {
        pageIndex: pageIndex,
        pageSize: pageSize,
        pageSort: pageSort
      }
    });
  },
  // 关注我的
  getFollowList(pageIndex, pageSize, pageSort) {
    return service({
      url: '/api/v1/company/resume/follow/list',
      method: 'get',
      params: {
        pageIndex: pageIndex,
        pageSize: pageSize,
        pageSort: pageSort
      }
    });
  },
  // 删除 我收到的简历
  deleteApply(ids) {
    return service.delete(`/api/v1/company/resume/apply/delete`, {data: {
      apply_ids: ids
    }});
  },
  // 删除我收藏的简历
  deleteCollect(ids) {
    return service.delete(`/api/v1/company/resume/collect/delete`, {data: {
      collect_ids: ids
    }});
  },
  // 删除我看过的简历
  deleteViews(ids) {
    return service.delete(`/api/v1/company/resume/views/delete`, {data: {
      views_ids: ids
    }});
  },
  // 删除关注我的的简历
  deleteFollow(ids) {
    return service.delete(`/api/v1/company/resume/follow/delete`, {data: {
      follow_ids: ids
    }});
  },
  // 收藏简历
  collectResume(id) {
    return service.post('/api/v1/company/resume/collect', {
      resume_id: id
    });
  },
  // 备注简历
  remarkResume(id, remark) {
    return service.patch(`/api/v1/company/resume/apply/${id}/remark`, {
      remark
    });
  },

  // 查看申请的简历
  viewApply(applyId) {
    return service.patch(`/api/v1/company/resume/apply/${applyId}/viewed`, {});
  },

  infoAll() {
    return service.get(`/api/v1/info/all`, {});
  },
  // 查看用户简历
  getResume(id) {
    return service.get(`/api/v1/resume/${id}`);
  },
  // 查看隐藏信息
  getHiddenInfo(id) {
    return service.get(`/api/v1/resume/${id}/contact`);
  },
  // 打印简历
  printResume(id) {
    return service.get(`/api/v1/resume/${id}/print`)
  },
  // 校验企业是否有权限查看简历
  checkLookResume(id) {
    return service.get(`/api/v1/resume/${id}/checkLookResume`)
  }
};



// WEBPACK FOOTER //
// ./src/api/enterprise-resume.js